import { ReactComponent as LockIcon } from 'resources/img/svg/common/lock.svg';
import { ReactComponent as ArrowLeftIcon } from 'resources/img/svg/common/arrowLeft-16.svg';
import { ReactComponent as ArrowRightIcon } from 'resources/img/svg/common/arrowRight.svg';
import { ReactComponent as InfoFilledIcon } from 'resources/img/svg/common/infoFilled.svg';
import { ReactComponent as LockoutDateCalendarIcon } from 'resources/img/svg/common/lockoutDateCalendar.svg';
import { ReactComponent as NotificationsBellFilledIcon } from 'resources/img/svg/notificationsBellFilled.svg';
import { ReactComponent as CheckMarkIconIcon } from 'resources/img/svg/checkMarkIcon.svg';

import { IconmoonFont } from 'vibo-ui/Icon';
import { NotificationMetadata, NotificationType } from './interface';

export const getDefaultEventUrl = (id: string) => `/event/${id}/timeline`;

export const notificationRedirectsByType = {
  [NotificationType.accountStatusChangedToActivated]: () => '/settings',
  [NotificationType.accountStatusChangedToChargeFailed]: () => '/settings',
  [NotificationType.accountStatusChangedToLimited]: () => '/settings',
  [NotificationType.eventLocked]: ({ eventId }: NotificationMetadata) =>
    getDefaultEventUrl(eventId),
  [NotificationType.lockoutDate]: ({ eventId }: NotificationMetadata) =>
    getDefaultEventUrl(eventId),
  [NotificationType.hostGuestJoinedEvent]: ({ eventId }: NotificationMetadata) =>
    `/event/${eventId}/users`,
  [NotificationType.hostGuestLeftEvent]: ({ eventId }: NotificationMetadata) =>
    `/event/${eventId}/users`,
  [NotificationType.customNotification]: ({ eventId }: NotificationMetadata) =>
    getDefaultEventUrl(eventId),
  [NotificationType.questionAnswered]: ({ eventId, sectionId, questionId }: NotificationMetadata) =>
    `/event/${eventId}/timeline/${sectionId}?targetQuestionId=${questionId}`,
  [NotificationType.songsUpdated]: ({ eventId, sectionId }: NotificationMetadata) =>
    `/event/${eventId}/timeline/${sectionId}`,
  [NotificationType.notesUpdated]: ({ eventId, sectionId }: NotificationMetadata) =>
    `/event/${eventId}/timeline/${sectionId}`,
};

export const notificationIconByType = {
  [NotificationType.accountStatusChangedToActivated]: InfoFilledIcon,
  [NotificationType.accountStatusChangedToChargeFailed]: InfoFilledIcon,
  [NotificationType.accountStatusChangedToLimited]: InfoFilledIcon,
  [NotificationType.eventLocked]: LockIcon,
  [NotificationType.lockoutDate]: LockoutDateCalendarIcon,
  [NotificationType.hostGuestJoinedEvent]: ArrowRightIcon,
  [NotificationType.hostGuestLeftEvent]: ArrowLeftIcon,
  [NotificationType.customNotification]: NotificationsBellFilledIcon,
  [NotificationType.questionAnswered]: CheckMarkIconIcon,
  [NotificationType.songsUpdated]: IconmoonFont['musicNoteDoubleOutlined-16'],
  [NotificationType.notesUpdated]: IconmoonFont['notes-16'],
};

export const NOTIFICATIONS_PAGINATION = {
  skip: 0,
  limit: 20,
};

export const MAX_NOTIFICATIONS_CROP_COUNT = 99;

export const TOOLTIP_ALIGN = { offset: [2, 16] };

export const NOTIF_PLACEHOLDERS = Array.from({ length: 10 }, el => el);
